import React from "react";

import Position from "./Position";

var BottomRight = createClass({
  render: function() {
    const { children, absolute, css_class } = this.props;
    return (
      <Position absolute={absolute} position="bottom_right" style={css_class}>
        {children}
      </Position>
    );
  },
});

module.exports = BottomRight;
